import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { CreateUpdateTrackmanParameterCategoryRequest } from 'types/admin/trackmanParameterCategories';
import { getErrorMessage } from 'utilities/ErrorHelper';

type UpdatePayload = {
  categoryId: string;
  request: CreateUpdateTrackmanParameterCategoryRequest;
};

export const useUpdateTrackmanParameterCategory = () => {
  const service = useServices().trackmanParameterCategoriesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: ({ categoryId, request }: UpdatePayload) => service.updateCategory(categoryId, request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminTrackmanParameterCategories'] });
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
